import { useState, useCallback } from 'react'

import { PersonListResult, listPeople } from '../../../../../services/person'
import { Pagination } from '../../../../../contexts/PaginationContext'

import { formatPerson, PersonFormatted } from '../../../utils/formatPerson'

export interface QueryParameters {
  search?: string
}

export function usePeopleList() {
  const [loading, setLoading] = useState(false)
  const [people, setPeople] = useState<PersonFormatted[]>([])
  const [totalItems, setTotalItems] = useState(0)

  const fetchPeople = useCallback((pagination: Pagination<QueryParameters>) => {
    const { page, limit, orderBy, order, query } = pagination
    const { search } = query || {}

    const onSuccess = (result: PersonListResult) => {
      setPeople(result.people.map(formatPerson))
      setTotalItems(result.total)
    }

    Promise.resolve()
      .then(() => setLoading(true))
      .then(() => listPeople({ page, limit, orderBy, order, search }))
      .then(result => onSuccess(result))
      .finally(() => setLoading(false))
  }, [])

  return {
    loading,
    people,
    totalItems,
    fetchPeople
  }
}
